import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const BlogPostTopicIdes = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <rect
          width="248"
          height="143"
          rx="8"
          fill="#FFCBCB"
        />
        <path
          d="M88.4275 70.9675H41V117H88.4275V70.9675Z"
          fill="white"
        />
        <path
          d="M88.362 71.0327H41.0654V67.1531C41.0654 66.3169 41.3976 65.5148 41.9889 64.9235C42.5802 64.3322 43.3822 64 44.2185 64H85.2089C86.0452 64 86.8472 64.3322 87.4385 64.9235C88.0298 65.5148 88.362 66.3169 88.362 67.1531V71.0327Z"
          fill="#E3E3E3"
        />
        <path
          d="M47.3717 99.4106H82.0559"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.3717 104.991H82.0559"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.0654 71.0329H88.362"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.1599 68.3957C47.9509 68.3957 47.7504 68.3127 47.6025 68.1648C47.4547 68.017 47.3716 67.8165 47.3716 67.6074C47.3716 67.3984 47.4547 67.1979 47.6025 67.05C47.7504 66.9022 47.9509 66.8192 48.1599 66.8192"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M48.1599 68.3955C48.3689 68.3955 48.5694 68.3125 48.7172 68.1646C48.8651 68.0168 48.9481 67.8163 48.9481 67.6072C48.9481 67.3982 48.8651 67.1977 48.7172 67.0499C48.5694 66.902 48.3689 66.819 48.1599 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M54.4661 68.3955C54.257 68.3955 54.0565 68.3125 53.9087 68.1646C53.7608 68.0168 53.6778 67.8163 53.6778 67.6072C53.6778 67.3982 53.7608 67.1977 53.9087 67.0499C54.0565 66.902 54.257 66.819 54.4661 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M54.4661 68.3955C54.6752 68.3955 54.8757 68.3125 55.0235 68.1646C55.1714 68.0168 55.2544 67.8163 55.2544 67.6072C55.2544 67.3982 55.1714 67.1977 55.0235 67.0499C54.8757 66.902 54.6752 66.819 54.4661 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M60.7723 68.3955C60.5632 68.3955 60.3627 68.3125 60.2149 68.1646C60.0671 68.0168 59.984 67.8163 59.984 67.6072C59.984 67.3982 60.0671 67.1977 60.2149 67.0499C60.3627 66.902 60.5632 66.819 60.7723 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M60.7723 68.3953C60.9814 68.3953 61.1819 68.3123 61.3297 68.1645C61.4776 68.0166 61.5606 67.8161 61.5606 67.6071C61.5606 67.398 61.4776 67.1975 61.3297 67.0497C61.1819 66.9018 60.9814 66.8188 60.7723 66.8188"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M41 112.692V67.1531C41 66.3169 41.3322 65.5148 41.9235 64.9235C42.5148 64.3322 43.3169 64 44.1531 64H85.1436C85.9798 64 86.7818 64.3322 87.3731 64.9235C87.9645 65.5148 88.2967 66.3169 88.2967 67.1531V112.692"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.8547 80.4951H49.3954C48.9773 80.4951 48.5763 80.6612 48.2806 80.9569C47.9849 81.2525 47.8188 81.6535 47.8188 82.0717V91.531C47.8188 91.9491 47.9849 92.3501 48.2806 92.6458C48.5763 92.9415 48.9773 93.1076 49.3954 93.1076H80.8547C81.2729 93.1076 81.6739 92.9415 81.9695 92.6458C82.2652 92.3501 82.4313 91.9491 82.4313 91.531V82.0717C82.4313 81.6535 82.2652 81.2525 81.9695 80.9569C81.6739 80.6612 81.2729 80.4951 80.8547 80.4951Z"
          fill="#66E1FF"
        />
        <path
          d="M81.9709 80.9525C81.8243 80.8062 81.6502 80.6903 81.4587 80.6113C81.2671 80.5323 81.0619 80.4918 80.8547 80.4922H49.3954C48.9773 80.4922 48.5763 80.6583 48.2806 80.954C47.985 81.2496 47.8189 81.6506 47.8189 82.0687V91.5281C47.8185 91.7353 47.8589 91.9405 47.9379 92.132C48.0169 92.3235 48.1329 92.4976 48.2792 92.6443L81.9709 80.9525Z"
          fill="#C2F3FF"
        />
        <path
          d="M80.7893 80.4951H49.33C48.9118 80.4951 48.5108 80.6612 48.2152 80.9569C47.9195 81.2525 47.7534 81.6535 47.7534 82.0717V91.531C47.7534 91.9491 47.9195 92.3501 48.2152 92.6458C48.5108 92.9415 48.9118 93.1076 49.33 93.1076H80.7893C81.2074 93.1076 81.6084 92.9415 81.9041 92.6458C82.1998 92.3501 82.3659 91.9491 82.3659 91.531V82.0717C82.3659 81.6535 82.1998 81.2525 81.9041 80.9569C81.6084 80.6612 81.2074 80.4951 80.7893 80.4951Z"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M147.855 70.9675H100.427V117H147.855V70.9675Z"
          fill="white"
        />
        <path
          d="M147.789 71.0327H100.493V67.1531C100.493 66.3169 100.825 65.5148 101.416 64.9235C102.008 64.3322 102.81 64 103.646 64H144.636C145.473 64 146.275 64.3322 146.866 64.9235C147.457 65.5148 147.789 66.3169 147.789 67.1531V71.0327Z"
          fill="#E3E3E3"
        />
        <path
          d="M106.734 84.2192H122.181"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.734 89.7988H122.181"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.799 99.4106H141.483"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.799 104.991H141.483"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.493 71.0329H147.789"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.587 68.3957C107.378 68.3957 107.178 68.3127 107.03 68.1648C106.882 68.017 106.799 67.8165 106.799 67.6074C106.799 67.3984 106.882 67.1979 107.03 67.05C107.178 66.9022 107.378 66.8192 107.587 66.8192"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M107.587 68.3955C107.796 68.3955 107.997 68.3125 108.145 68.1646C108.293 68.0168 108.376 67.8163 108.376 67.6072C108.376 67.3982 108.293 67.1977 108.145 67.0499C107.997 66.902 107.796 66.819 107.587 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M113.894 68.3955C113.684 68.3955 113.484 68.3125 113.336 68.1646C113.188 68.0168 113.105 67.8163 113.105 67.6072C113.105 67.3982 113.188 67.1977 113.336 67.0499C113.484 66.902 113.684 66.819 113.894 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M113.894 68.3955C114.103 68.3955 114.303 68.3125 114.451 68.1646C114.599 68.0168 114.682 67.8163 114.682 67.6072C114.682 67.3982 114.599 67.1977 114.451 67.0499C114.303 66.902 114.103 66.819 113.894 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M120.2 68.3955C119.991 68.3955 119.79 68.3125 119.642 68.1646C119.494 68.0168 119.411 67.8163 119.411 67.6072C119.411 67.3982 119.494 67.1977 119.642 67.0499C119.79 66.902 119.991 66.819 120.2 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M120.2 68.3953C120.409 68.3953 120.609 68.3123 120.757 68.1645C120.905 68.0166 120.988 67.8161 120.988 67.6071C120.988 67.398 120.905 67.1975 120.757 67.0497C120.609 66.9018 120.409 66.8188 120.2 66.8188"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M100.427 112.692V67.1531C100.427 66.3169 100.76 65.5148 101.351 64.9235C101.942 64.3322 102.744 64 103.581 64H144.571C145.407 64 146.209 64.3322 146.801 64.9235C147.392 65.5148 147.724 66.3169 147.724 67.1531V112.692"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M140.282 80.4951H130.823C130.405 80.4951 130.004 80.6612 129.708 80.9569C129.412 81.2525 129.246 81.6535 129.246 82.0717V91.531C129.246 91.9491 129.412 92.3501 129.708 92.6458C130.004 92.9415 130.405 93.1076 130.823 93.1076H140.282C140.7 93.1076 141.101 92.9415 141.397 92.6458C141.693 92.3501 141.859 91.9491 141.859 91.531V82.0717C141.859 81.6535 141.693 81.2525 141.397 80.9569C141.101 80.6612 140.7 80.4951 140.282 80.4951Z"
          fill="#66E1FF"
        />
        <path
          d="M141.398 80.9525C141.252 80.8062 141.078 80.6903 140.886 80.6113C140.695 80.5323 140.489 80.4918 140.282 80.4922H130.823C130.405 80.4922 130.004 80.6583 129.708 80.954C129.412 81.2496 129.246 81.6506 129.246 82.0687V91.5281C129.246 91.7353 129.286 91.9405 129.365 92.132C129.444 92.3235 129.56 92.4976 129.707 92.6443L141.398 80.9525Z"
          fill="#C2F3FF"
        />
        <path
          d="M140.217 80.4951H130.757C130.339 80.4951 129.938 80.6612 129.643 80.9569C129.347 81.2525 129.181 81.6535 129.181 82.0717V91.531C129.181 91.9491 129.347 92.3501 129.643 92.6458C129.938 92.9415 130.339 93.1076 130.757 93.1076H140.217C140.635 93.1076 141.036 92.9415 141.332 92.6458C141.627 92.3501 141.793 91.9491 141.793 91.531V82.0717C141.793 81.6535 141.627 81.2525 141.332 80.9569C141.036 80.6612 140.635 80.4951 140.217 80.4951Z"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M207.282 70.9675H159.855V117H207.282V70.9675Z"
          fill="white"
        />
        <path
          d="M207.217 71.0327H159.92V67.1531C159.92 66.3169 160.252 65.5148 160.844 64.9235C161.435 64.3322 162.237 64 163.073 64H204.064C204.9 64 205.702 64.3322 206.293 64.9235C206.885 65.5148 207.217 66.3169 207.217 67.1531V71.0327Z"
          fill="#E3E3E3"
        />
        <path
          d="M166.227 80.4922H200.911"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.227 86.0723H200.911"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M159.92 71.0329H207.217"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.015 68.3957C166.806 68.3957 166.605 68.3127 166.457 68.1648C166.31 68.017 166.227 67.8165 166.227 67.6074C166.227 67.3984 166.31 67.1979 166.457 67.05C166.605 66.9022 166.806 66.8192 167.015 66.8192"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M167.015 68.3955C167.224 68.3955 167.424 68.3125 167.572 68.1646C167.72 68.0168 167.803 67.8163 167.803 67.6072C167.803 67.3982 167.72 67.1977 167.572 67.0499C167.424 66.902 167.224 66.819 167.015 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M173.321 68.3955C173.112 68.3955 172.911 68.3125 172.764 68.1646C172.616 68.0168 172.533 67.8163 172.533 67.6072C172.533 67.3982 172.616 67.1977 172.764 67.0499C172.911 66.902 173.112 66.819 173.321 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M173.321 68.3955C173.53 68.3955 173.731 68.3125 173.878 68.1646C174.026 68.0168 174.109 67.8163 174.109 67.6072C174.109 67.3982 174.026 67.1977 173.878 67.0499C173.731 66.902 173.53 66.819 173.321 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M179.627 68.3955C179.418 68.3955 179.218 68.3125 179.07 68.1646C178.922 68.0168 178.839 67.8163 178.839 67.6072C178.839 67.3982 178.922 67.1977 179.07 67.0499C179.218 66.902 179.418 66.819 179.627 66.819"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M179.627 68.3953C179.836 68.3953 180.037 68.3123 180.185 68.1645C180.332 68.0166 180.416 67.8161 180.416 67.6071C180.416 67.398 180.332 67.1975 180.185 67.0497C180.037 66.9018 179.836 66.8188 179.627 66.8188"
          stroke="#191919"
          strokeWidth="1.5"
        />
        <path
          d="M159.855 112.692V67.1531C159.855 66.3169 160.187 65.5148 160.778 64.9235C161.37 64.3322 162.172 64 163.008 64H203.998C204.835 64 205.637 64.3322 206.228 64.9235C206.819 65.5148 207.152 66.3169 207.152 67.1531V112.692"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.161 95.7993H181.608"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M166.161 101.379H181.608"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M199.71 92.0752H190.25C189.832 92.0752 189.431 92.2413 189.136 92.537C188.84 92.8326 188.674 93.2336 188.674 93.6518V103.111C188.674 103.529 188.84 103.93 189.136 104.226C189.431 104.522 189.832 104.688 190.25 104.688H199.71C200.128 104.688 200.529 104.522 200.824 104.226C201.12 103.93 201.286 103.529 201.286 103.111V93.6518C201.286 93.2336 201.12 92.8326 200.824 92.537C200.529 92.2413 200.128 92.0752 199.71 92.0752Z"
          fill="#66E1FF"
        />
        <path
          d="M200.826 92.5326C200.679 92.3863 200.505 92.2703 200.314 92.1914C200.122 92.1124 199.917 92.0719 199.71 92.0723H190.25C189.832 92.0723 189.431 92.2384 189.136 92.534C188.84 92.8297 188.674 93.2307 188.674 93.6488V103.108C188.673 103.315 188.714 103.521 188.793 103.712C188.872 103.904 188.988 104.078 189.134 104.224L200.826 92.5326Z"
          fill="#C2F3FF"
        />
        <path
          d="M199.644 92.0752H190.185C189.767 92.0752 189.366 92.2413 189.07 92.537C188.774 92.8326 188.608 93.2336 188.608 93.6518V103.111C188.608 103.529 188.774 103.93 189.07 104.226C189.366 104.522 189.767 104.688 190.185 104.688H199.644C200.062 104.688 200.463 104.522 200.759 104.226C201.055 103.93 201.221 103.529 201.221 103.111V93.6518C201.221 93.2336 201.055 92.8326 200.759 92.537C200.463 92.2413 200.062 92.0752 199.644 92.0752Z"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.98 42.3931V46.4479C128.98 48.5776 127.188 49.4349 124.5 49.4349C121.812 49.4349 120.02 48.5776 120.02 46.4479V42.3931"
          fill="#E3E3E3"
        />
        <path
          d="M128.98 42.3931V46.4479C128.98 48.5776 127.188 49.4349 124.5 49.4349C121.812 49.4349 120.02 48.5776 120.02 46.4479V42.3931"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.234 42.7142C130.022 42.0051 131.552 40.7675 132.62 39.1665C133.687 37.5655 134.241 35.6771 134.208 33.7532C134.162 31.193 133.124 28.7504 131.313 26.9398C129.503 25.1291 127.06 24.0916 124.5 24.0456C121.94 24.0912 119.497 25.1286 117.686 26.9394C115.875 28.7501 114.838 31.1929 114.792 33.7532C114.758 35.6772 115.312 37.5657 116.38 39.1668C117.447 40.7679 118.977 42.0054 120.766 42.7142H128.234Z"
          fill="#FFEF5E"
        />
        <path
          d="M124.5 28.8875C126.658 28.927 128.745 29.6723 130.439 31.0095C132.134 32.3467 133.344 34.2022 133.885 36.2922C134.107 35.4645 134.216 34.6103 134.208 33.7532C134.162 31.193 133.124 28.7504 131.313 26.9398C129.503 25.1291 127.06 24.0916 124.5 24.0456C121.94 24.0912 119.497 25.1286 117.686 26.9394C115.875 28.7501 114.838 31.1929 114.792 33.7532C114.784 34.6103 114.892 35.4645 115.115 36.2922C115.656 34.2022 116.866 32.3467 118.561 31.0095C120.255 29.6723 122.342 28.927 124.5 28.8875Z"
          fill="#FFF9BF"
        />
        <path
          d="M128.234 42.7142C130.022 42.0051 131.552 40.7675 132.62 39.1665C133.687 37.5655 134.241 35.6771 134.208 33.7532C134.162 31.193 133.124 28.7504 131.313 26.9398C129.503 25.1291 127.06 24.0916 124.5 24.0456C121.94 24.0912 119.497 25.1286 117.686 26.9394C115.875 28.7501 114.838 31.1929 114.792 33.7532C114.758 35.6772 115.312 37.5657 116.38 39.1668C117.447 40.7679 118.977 42.0054 120.766 42.7142H128.234Z"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.5 49.4349V51.6751"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.5 42.2661V35.9935L121.513 33.0065"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M120.02 45.7012H128.98"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.5 17.3249V20.3118"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M108.072 32.2598H111.493"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.805 21.0586L114.792 24.0456"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M140.928 32.2598H137.507"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M137.195 21.0586L134.208 24.0456"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.5 35.9935L127.487 33.0065"
          stroke="#191919"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </SvgIcon>
    );
  })
);
BlogPostTopicIdes.displayName = 'BlogPostTopicIdes';
